export class XLSXTemplateInfo {
    public pageHeader: {row: number, col: number};
    public projectName: {row: number, col: number};

    public row: number = 0;
    public rowHeader: number = 0;

    public positionHeader: number;
    public positionColumn: number;

    public imgHeader: number | null = null;
    public mainImageColumn: number | null = null;

    public snapshot: number | null = null;
    public imageColumnWidth: number | undefined;

    public articleInformationHeader: number;
    public articleInformationColumn: number | null = null;

    public manufacturerHeader: number;
    public manufacturerColumn: number | null = null;

    public descriptionHeader: number;
    public descriptionColumn: number | null;

    public quantityHeader: number;
    public quantityColumn: number | null = null;

    public singlePriceHeader: number;
    public singlePriceColumn: number | null = null;

    public totalPriceHeader: number;
    public totalPriceColumn: number | null = null;

    public fontSize: number;
    public fontFamily: string;

    // tslint:disable-next-line
    constructor(templateSheet: any) {
        for (let row: number = 1; row < 20; row++) {
            for (let col: number = 1; col < 20; col++) {
                switch (templateSheet.row(row).cell(col).value() as string) {
                    case '{PAGEHEADER}':
                        this.pageHeader = {row: row, col: col};
                        break;
                    case '{PROJECTNAME}':
                        this.projectName = {row: row, col: col};
                        break;
                    case '{POS}':
                        this.positionColumn = col;
                        this.row = row;
                        break;
                    case '{ARTICLEINFO}':
                        this.articleInformationColumn = col;
                        this.row = row;
                        templateSheet.row(row).cell(col).value('');
                        break;
                    case '{MANUFACTURER}':
                        this.manufacturerColumn = col;
                        this.row = row;
                        templateSheet.row(row).cell(col).value('');
                        break;
                    case '{DESCRIPTION}':
                        this.descriptionColumn = col;
                        this.row = row;
                        this.fontFamily = templateSheet.row(row).cell(col).style('fontFamily');
                        this.fontSize = templateSheet.row(row).cell(col).style('fontSize');
                        templateSheet.row(row).cell(col).value('');
                        break;
                    case '{COUNT}':
                        this.quantityColumn = col;
                        this.row = row;
                        break;
                    case '{PRICESINGLE}':
                        this.singlePriceColumn = col;
                        this.row = row;
                        break;
                    case '{PRICETOTAL}':
                        this.totalPriceColumn = col;
                        this.row = row;
                        break;
                    case '{POS-HEADER}':
                        this.positionHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{ARTICLEINFO-HEADER}':
                        this.articleInformationHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{MANUFACTURER-HEADER}':
                        this.manufacturerHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{DESCRIPTION-HEADER}':
                        this.descriptionHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{COUNT-HEADER}':
                        this.quantityHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{PRICESINGLE-HEADER}':
                        this.singlePriceHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{PRICETOTAL-HEADER}':
                        this.totalPriceHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{IMG-HEADER}':
                        this.imgHeader = col;
                        this.rowHeader = row;
                        break;
                    case '{IMG}':
                        this.mainImageColumn = col;
                        this.imageColumnWidth = templateSheet.column(col).width();
                        break;
                    case '{SNAPSHOT}':
                        this.snapshot = col;
                        break;
                    default:
                        break;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/articlelist-export/XLSXTemplateInfo.ts